import { useState, useCallback, useEffect } from "react";
import MainServices from "../../../../../services/MainServices";
import TimingFunctions from "../../../../../assets/functions/TimingFunctions";
import { notifyWarn } from "../../../../../assets/elements/Toast";

export function useCreatedByOptions({ filters }) {
  const { getEmployeesPersonalInfoMaster } = MainServices();
  const { deBounce } = TimingFunctions();
  const activeFilter = { key: "status", in: ["active", "inactive"] };

  const [createdByOptions, setCreatedByOptions] = useState([]);
  const [selectedCreatedBy, setSelectedCreatedBy] = useState("");

  const getCreatedByOptions = useCallback(
    async (filters = [], search) => {
      const mergedFilters = [
        activeFilter,
        ...(filters?.filter((f) => f.key !== "status") || []), // ensure no duplicate status filters
      ];

      const details = {
        filters: mergedFilters,
      };

      try {
        const response = await getEmployeesPersonalInfoMaster(details);
        if (response?.data?.data?.doc?.length >= 0) {
          const options = [
            ...(response?.data?.data?.doc?.map((employee) => ({
              label: employee.email,
              value: employee.publicId,
            })) || []),
          ];
          !search && setCreatedByOptions(options);
          return options;
        }
      } catch (error) {
        notifyWarn(
          error?.response?.data?.message || "An unexpected error occurred"
        );
        console.error("Error", error);
      }
    },
    [getEmployeesPersonalInfoMaster]
  );

  const onSearchCreatedByDebounce = useCallback(
    (inputValue, callback) => {
      deBounce(() => onSearchCreatedBy(inputValue, callback), 1000);
    },
    [deBounce]
  );

  const onSearchCreatedBy = useCallback(
    async (inputValue, callback) => {
      if (!inputValue) {
        callback(createdByOptions);
        return;
      }

      const filter = [
        {
          key: "email",
          iLike: inputValue,
        },
      ];
      const options = await getCreatedByOptions(filter, true);
      callback(options);
    },
    [createdByOptions, getCreatedByOptions]
  );

  useEffect(() => {
    getCreatedByOptions();
  }, []);

  return {
    createdByOptions,
    selectedCreatedBy,
    setSelectedCreatedBy,
    onSearchCreatedByDebounce,
    setCreatedByOptions,
  };
}
